import axios from "axios";
import StorageService from "./storageService";

let baseUrl = process.env.VUE_APP_CROPWISE_AUTHENTICATION_API;
let storageService = new StorageService();
export default class CropwiseService {
    constructor() {}

    login(username, password) {
        var bodyFormData = new FormData();
        bodyFormData.append('grant_type', 'password');
        bodyFormData.append('username', username);
        bodyFormData.append('password', password);

        return axios.post(
            `${baseUrl}oauth/token`,
            bodyFormData,
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Authorization": 'Basic cHJvdGVjdG9yOnBhc3NvbGFyZ28'
                },
            }
        ).then((response) => {
            if (response.status == 400) {
                return response;
            } else {
                storageService.set('cropwise_access_key', response.data.access_token);
                return response.data.access_token;
            }
        }).catch((err) => {
            console.log(err)
        });
    }


    getUser(access_token) {
        let userData = storageService.get(access_token);
        if (userData) {
            var  promise= new Promise(function(resolve,){
                resolve(JSON.parse(userData));
              });

            return promise;
        } else {
            return axios.get(
                `${baseUrl}v2/accounts/me`,
                {
                    headers: {
                        "Authorization": `Bearer ${access_token}`
                    }
                },
            ).then(response => {

                let profile = {
                    email: response.data.email,
                    name: response.data.name
                };
                let user = { ...response.data, profile };
                storageService.set(access_token,JSON.stringify(user));

                return user;
            }).catch(err => {
                console.log(err)
            });
        }
    }

    logout() {
        let currentLocation = window.location.href;
        return axios.get( process.env.VUE_APP_CROPWISE_EXIT,
            {
                withCredentials: true,
            }).then(()=>{
                window.location.href = currentLocation;
            });
     
    }
}
